// extracted by mini-css-extract-plugin
module.exports = {"EditionFooter":"EditionFooter_EditionFooter__98tFE","ButtonContainer":"EditionFooter_ButtonContainer__12fIm","Button":"EditionFooter_Button__3g8l5"};